import React from "react";

const Youtube = props => (
  <svg  width={22} height={16} viewBox="0 0 22 16" {...props}>
    <path d="M10.9998 0C6.68506 0 2.37038 0.344633 1.42223 1.0342C-0.474077 2.41334 -0.474077 13.5865 1.42223 14.9656C3.31852 16.3448 18.6815 16.3448 20.5778 14.9656C22.4741 13.5865 22.4741 2.41334 20.5778 1.0342C19.6296 0.344633 15.3147 0 10.9998 0ZM8.81161 4.65493L14.3642 8.00007L8.81161 11.3449V4.65493Z" fill="white"/>
  </svg>
);

export default Youtube;